// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/medical-certificate-restrictions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/medical-certificate-restrictions/medical-certificate-restrictions.js';

mount([g0]);
